import { QueryClient } from '@tanstack/react-query';

import { api, ReportOrgan } from '@/api';
import { OrganName } from '@/store';

const reportOrgansMapCache = new WeakMap<ReportOrgan[], Record<OrganName, ReportOrgan>>();

export function getReportOrgansMapFromCache(
  queryClient: QueryClient,
  reportUuid: string,
): Record<OrganName, ReportOrgan> | undefined {
  const listOrgans = queryClient.getQueryData<ReportOrgan[]>([
    api.fct.reportOrgan.KEY.GET_REPORT_ORGANS,
    reportUuid,
  ]);

  if (!listOrgans) {
    return undefined;
  }

  const cachedMap = reportOrgansMapCache.get(listOrgans);

  if (cachedMap) {
    return cachedMap;
  }

  const map = listOrgans.reduce(
    (acc, reportOrgan) => {
      acc[reportOrgan.organ] = reportOrgan;

      return acc;
    },
    {} as Record<OrganName, ReportOrgan>,
  );

  reportOrgansMapCache.set(listOrgans, map);

  return map;
}
